<script>
import Vue from 'vue'
import {mapState, mapActions} from 'vuex'

export default Vue.extend({
    props: {
        groupId: {
            type: String,
            required: true
        }
    },
    mounted() {
        if (!this.selectedGroup) {
            this.selectGroup(this.groupId)
        }
    },
    computed: {
        ...mapState({
            'selectedGroup': state => state.groups.selected,
        })
    },
    methods: {
        ...mapActions({
            selectGroup: 'groups/selectGroup'
        })
    }
})
</script>